const EntityStore = require("stores/abstract/EntityStore");
const env = require("services/env");

// NOTE: There's no route (endpoint) as this store would be read only
module.exports = new EntityStore(env.get("stores.order", {}));


// WEBPACK FOOTER //
// ./resources/js/stores/OrderStore.js